'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _changePassword = require('./change-password.html');

var _changePassword2 = _interopRequireDefault(_changePassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _changePassword2.default,
  bindings: {
    credentials: '<',
    passwordChanged: '&',
    requireCurrentPassword: '<'
  },
  controller: function () {
    function ChangePasswordComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, ChangePasswordComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(ChangePasswordComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.passwordChanged(this.EventEmitter({
          credentials: this.credentials
        }));
      }
    }]);

    return ChangePasswordComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/change-password/change-password.component.js